<script setup>
import { computed, onMounted, ref, watch } from "vue"
import { Icon, Tabs, Tab, Input, Label, Textarea, Select, MediaUploaderButton, Toggle, ColorPickerDefault } from "@components"
import { regex } from "@utils"

import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()

import { useSettings } from '@store/settings'
const $settings = useSettings()

const useColorPalette = () => {
    const showAddNewColor = ref(false)

    const isValid = ref(false)

    const newColor = ref('')

    const addNewColor = () => {
        $settings.customizer.sidebar.background_colors.push(newColor.value)
        newColor.value = ''
        showAddNewColor.value = false
        isValid.value = false
    }

    watch(newColor, () => {
        isValid.value = false

        // check code length with #
        if (newColor.value.length !== 7) return console.log('Must be 7 characters with #')

        // check duplicate
        if ($settings.customizer.sidebar.background_colors.includes(String(newColor.value).toUpperCase())) return console.log('Duplicate color')

        // check color code
        if (!regex.hexCode.test(newColor.value)) return console.log('Invalid color code')

        isValid.value = true
    })

    return { showAddNewColor, addNewColor, newColor, isValid }
}

const { showAddNewColor, addNewColor, newColor, isValid } = useColorPalette()

const positions = ref([
    {
        label: "Left bottom",
        value: "Left bottom",
        icon: "leftBottom"
    },
    {
        label: "Left top",
        value: "Left top",
        icon: "leftTop"
    },
    {
        label: "Right bottom",
        value: "Right bottom",
        icon: "rightBottom"
    },
    {
        label: "Right top",
        value: "Right top",
        icon: "rightTop"
    }
])

const changePosition = (value) => {
    $settings.customizer.sidebar.content_position = value
}

onMounted(() => {
    // prebook_admin.settings.customizer.sidebar['show_background'] = false
    // prebook_admin.settings.customizer.sidebar['background_type'] = 'color'
    // prebook_admin.settings.customizer.sidebar['background_color'] = '#FFFEFE'
    // prebook_admin.settings.customizer.sidebar['background_colors'] = colors.value
    // prebook_admin.settings.customizer.sidebar['background_image'] = ''
    // prebook_admin.settings.customizer.sidebar['content_position'] = 'Left top'



    // if ($settings.customizer.sidebar.show_background) {
    //     router.push({
    //         query: {
    //             ...route.query,
    //             background: $settings.customizer.sidebar.background_type || 'image'
    //         }
    //     })
    // }
})

const positionIcon = computed(() => {
    switch ($settings.customizer.sidebar.content_position) {
        case 'Left bottom':
            return 'leftBottom'
        case 'Left top':
            return 'leftTop'
        case 'Right bottom':
            return 'rightBottom'
        case 'Right top':
            return 'rightTop'
    }
})

const logo = computed(() => {
    if ($settings.customizer.sidebar.business_custom_logo !== '') return $settings.customizer.sidebar.business_custom_logo

    return $settings.business.full_logo_url
})

// const businessName = computed(() => {
//     return $settings.business.name
// })

const setbackgroundType = (value) => {
    $settings.customizer.sidebar.background_type = String(value).toLocaleLowerCase()
}
</script>

<template>
    <div>
        <div title="Ensure to upload 320px x 320px logo for better quality">
            <div class="text-[#344054] font-medium text-sm">Full Logo</div>
            <div class="relative grid grid-cols-2 gap-[22px] items-center mt-3">
                <MediaUploaderButton class="w-full" name="custom_logo_url" :crop="true" :ratio="0" v-model="$settings.customizer.sidebar.business_custom_logo">
                    <div class="p-2 rounded-lg border border-[#B692F6] border-dashed">
                        <!-- <Icon v-if="!logo" name="logomark" width="72px" height="68px" class="text-[#101828]" /> -->
                        <img v-if="!logo" :src="Image('prebook-logo-light.svg')" class="w-[72px] h-[68px] m-auto" />
                        <img v-if="logo" :src="logo" class="w-full max-h-full m-auto" />
                    </div>
                </MediaUploaderButton>

                <Icon v-if="$settings.customizer.sidebar.business_custom_logo != ''" @click="$settings.customizer.sidebar.business_custom_logo = ''" name="xClose" size="24px" class="text-white absolute p-1 -top-1 left-[134px] cursor-pointer bg-[#475467] rounded-full"></Icon>

                <MediaUploaderButton class="w-full" name="custom_logo_url" :crop="true" :ratio="0" v-model="$settings.customizer.sidebar.business_custom_logo">
                    <div class="text-[#7F56D9] flex gap-2 items-center">
                        <Icon name="cameraPlus" size="20px" />
                        <div class="font-semibold text-sm">Change Logo</div>
                    </div>
                </MediaUploaderButton>
            </div>

        </div>

        <div class="bg-[#F2F4F7] h-[1px] w-full my-5"></div>

        <!-- for business profile -->
        <div v-if="$settings.addons.staffs">
            <div>
                <div class="flex gap-1 justify-between">
                    <div class="text-[#344054] font-medium text-sm">
                        Company Name <div class="text-[#D92D20] inline-block">*</div>
                    </div>
                    <ColorPickerDefault v-model="$settings.customizer.sidebar.business_name_color" class="w-6" />

                </div>

                <Input required v-model="$settings.customizer.sidebar.business_custom_name" type="text" size="sm" class="mt-1.5" inputClass="text-base"></Input>
            </div>
            <div class="mt-5">
                <div class="flex gap-1 justify-between">
                    <div class="text-[#344054] font-medium text-sm">About Company</div>
                    <!-- <input type="color" class="w-6" v-model="$settings.customizer.sidebar.business_about_color"> -->
                    <ColorPickerDefault v-model="$settings.customizer.sidebar.business_about_color" class="w-6" />
                </div>
                <Textarea v-model="$settings.customizer.sidebar.business_custom_about" placeholder="Enter about the company" class="mt-1.5" autoHeight></Textarea>
            </div>
        </div>

        <!-- for service provider -->
        <div v-if="!$settings.addons.staffs">
            <div>
                <div class="flex gap-1 justify-between">
                    <div class="text-[#344054] font-medium text-sm">
                        Display Name <div class="text-[#D92D20] inline-block">*</div>
                    </div>
                    <ColorPickerDefault v-model="$settings.customizer.sidebar.provider_display_name_color" class="w-6" />

                </div>

                <Input required v-model="$settings.customizer.sidebar.provider_display_name" type="text" size="sm" class="mt-1.5" inputClass="text-base"></Input>
            </div>
            <div class="mt-5">
                <div class="flex gap-1 justify-between">
                    <div class="text-[#344054] font-medium text-sm">Bio</div>
                    <!-- <input type="color" class="w-6" v-model="$settings.customizer.sidebar.business_about_color"> -->
                    <ColorPickerDefault v-model="$settings.customizer.sidebar.provider_bio_color" class="w-6" />
                </div>
                <Textarea v-model="$settings.customizer.sidebar.provider_bio" placeholder="Enter bio" class="mt-1.5" autoHeight></Textarea>
            </div>
        </div>

        <div class="bg-[#F2F4F7] h-[1px] w-full my-5"></div>

        <div>
            <div class="text-[#344054] font-medium text-sm flex justify-between items-center">
                Background <Toggle v-model="$settings.customizer.sidebar.show_background"></Toggle>
            </div>
            <Tabs @update:tab="value => setbackgroundType(value)" v-if="$settings.customizer.sidebar.show_background" queryName="background" default="color" class="mt-[14px]">
                <Tab id="color">Color</Tab>
                <Tab id="image">Image</Tab>

                <template #color>
                    <div>
                        <div class="grid grid-cols-10 gap-y-2 gap-x-1.5">
                            <div v-for="(color, index) in $settings.customizer.sidebar.background_colors" :key="index" class="flex items-center justify-center w-[25px] h-[25px] rounded-full cursor-pointer" :style="{ 'background-color': color }" @click="$settings.customizer.sidebar.background_color = color" :class="{ 'border-2 border-[#D0D5DD]': $settings.customizer.sidebar.background_color == color || color == '#FFFEFE' }">
                                <Icon size="11px" name="check" :class="$settings.customizer.sidebar.background_color == '#FFFEFE' ? '!text-[#7F56D9]' : 'text-[#FFFFFF]'" v-if="$settings.customizer.sidebar.background_color == color"></Icon>
                            </div>
                            <Icon @click="showAddNewColor = !showAddNewColor" :name="showAddNewColor ? 'xClose' : 'plusCircle'" size="25px" class="text-[#98A2B3] cursor-pointer"></Icon>
                        </div>

                        <div class="mt-[14px]" v-if="showAddNewColor">
                            <Label>Add Color (HEX)</Label>
                            <Input type="text" title="Must be 7 characters with # and unique color" v-model="newColor" placeholder="#000000" size="sm" class="mt-1.5" inputClass="text-base !text-[#667085]" classAfter="cursor-pointer text-[#7F56D9] font-semibold border-none pr-[14px] pl-2">
                            <template #after v-if="isValid">
                                <div @click="addNewColor" class="flex items-center gap-1">
                                    <Icon name="check" size="16px" />
                                    Save
                                </div>
                            </template>
                            </Input>
                        </div>
                    </div>
                </template>

                <template #image>
                    <MediaUploaderButton v-if="!$settings.customizer.sidebar.background_image" :crop="true" :ratio="240 / 518" v-model="$settings.customizer.sidebar.background_image" name="form_background" class=" mt-1.5 w-full" />
                    <div class="w-full h-[230px] rounded-lg relative bg-contain bg-center bg-no-repeat" :style="{ 'background-image': `url(${$settings.customizer.sidebar.background_image})` }" v-if="$settings.customizer.sidebar.background_image">
                        <Icon @click="$settings.customizer.sidebar.background_image = ''" name="xClose" size="20px" class="text-[#475467] z-10 absolute top-[14px] right-[14px] cursor-pointer bg-white rounded-full"></Icon>
                        <div class="absolute top-0 left-0 w-[106px] h-full bg-[#00000099]"></div>
                        <div class="absolute top-0 right-0 w-[106px] h-full bg-[#00000099]"></div>
                    </div>
                    <MediaUploaderButton v-if="$settings.customizer.sidebar.background_image" :crop="true" :ratio="240 / 518" v-model="$settings.customizer.sidebar.background_image" name="form_background">
                        <div class="flex gap-2 mt-[22px] font-semibold text-sm text-[#6941C6] items-center justify-center">
                            <Icon name="cameraPlus" size="20px"></Icon>
                            Change Image
                        </div>
                    </MediaUploaderButton>
                </template>
            </Tabs>
        </div>

        <div class="bg-[#F2F4F7] h-[1px] w-full my-5"></div>

        <div>
            <div class="text-[#344054] font-medium text-sm">Content Position</div>
            <Select :iconLeft="positionIcon" iconLeftClass="text-[#7F56D9] w-6" v-model="$settings.customizer.sidebar.content_position" :options="positions" @change="value => changePosition(value)" class="my-1.5" selectionContainer="py-[10px]"></Select>

        </div>
    </div>
</template>


<style>

</style>